import React from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./Home.css"; // your custom CSS
import { useNavigate } from "react-router-dom";

// Import your logos
import runpayrollLogo from "../pictures/runpayroll.png";
import calendarLogo from "../pictures/calendarLogo.png";

import comingSoon from "../pictures/comingSoon.png";

const ResponsiveGridLayout = WidthProvider(Responsive);

const widgets = [
  { key: "RunPayroll", title: "RunPayroll.com", url: "https://www.runpayroll.com", icon: runpayrollLogo },
  { key: "CompanyFiles", title: "Company Files", url: "https://aro365520549.sharepoint.com/sites/CompanyFiles" },
  { key: "Help", title: "Support & Help", url: "https://aro365520549.sharepoint.com/:f:/s/CompanyFiles/IgCP2J2Q3T_wS6hH9jTI-7CfAdE-AiLvjHIyyq_eHQomiTc?e=hleEUv" },
  { key: "MileageForm", title: "Submit Miles", url: "/mileage" },
  { key: "TrainingCalendar", title: "Training Calendar", url: "/training-calendar", icon: calendarLogo },
];

// Layout config: x, y = position; w = width; h = height
const layout = [
  { i: "RunPayroll", x: 0, y: 0, w: 3, h: 1 },
  { i: "CompanyFiles", x: 0, y: 4, w: 3, h: 1 },
  { i: "Help", x: 0, y: 2, w: 3, h: 1 },
  { i: "MileageForm", x: 0, y: 3, w: 3, h: 1 },
  { i: "TrainingCalendar", x: 0, y: 1, w: 3, h: 1 },
];

export default function HomeEmployee() {
  const navigate = useNavigate();

  // Define breakpoints and cols
  const breakpoints = { lg: 520, sm: 0 };
  const cols = { lg: 3, sm: 1 };

  // Layouts for each breakpoint
  const layouts = {
    lg: layout,
    sm: layout.map(item => ({ ...item, x: 0, w: 1 })), // stack vertically on small screens
  };

  const handleClick = (url) => {
    if (url.startsWith("http")) {
      window.open(url, "_blank", "noopener");
    } else {
      navigate(url);
      window.scrollTo(0, 0); // Scroll to top after navigation
    }
  };

  return (
    <div className="home-container-agent">
      <div className="grid-wrapper">
        <ResponsiveGridLayout
          className="layout"
          layouts={layouts}
          breakpoints={breakpoints}
          cols={cols}
          rowHeight={150}
          isResizable={false}
          isDraggable={false}
        >
          {widgets.map((widget) => (
            <div
              key={widget.key}
              className="widget-card"
              onClick={() => handleClick(widget.url)}
            >
              {widget.icon ? (
              <img src={widget.icon} alt={widget.title} className="widget-icon" />
                ) : (
                  <div className="widget-title">{widget.title}</div>
                )}
            </div>
          ))}
        </ResponsiveGridLayout>
      </div>
    </div>
  );
}
